export default function UserGroup() {
  return <>UserGroup</>;
}
